// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { DatePicker } from 'antd';
import * as moment from 'moment';
// Component
import Template from '../../components/Template';
import PopUp from '../../components/Modal';
import FixedJobRequest from '../../components/JobRequest';

// Hooks
import useReport from '../../hooks/useReport';

// Images
import infoAlert from '../../../sass/images/alert/info-alert.svg';
import alert from '../../../sass/images/alert/alert.svg';
import calendarIcon from '../../../sass/images/icons/calendar-day.svg';
import successAlert from '../../../sass/images/alert/icon-check-alert.svg';
import errorAlert from '../../../sass/images/alert/icon-error-alert.svg';
import alertIcon from '../../../sass/images/icons/modal-alert.svg';

// Utils
import { contactEmail, contacNumber } from '../../helpers';

function JobRequest(props) {
  const { t } = props;
  const { register, handleSubmit, errors, control, reset } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUnregister: true,
  });
  const {
    alertUpdate,
    messageError,
    modalErrorDate,
    messageAlert,
    onSubmit,
    isCompleted,
    setIsCompleted,
    onPanelChange,
    onPanelChange2,
    modalError,
    closeModal,
    typeExcel,
    useSetTypeExcel,
  } = useReport(reset);
  return (
    <Template type={4} classNameContainer="maintenance" className="container_menu maintenance">
      <>
        {modalError ? (
          <PopUp
            open={modalError}
            close={closeModal}
            icon={alertIcon}
            title={t('title-modal')}
            description={t('description-modal')}
            go={t('keep-it')}
            accept={closeModal}
            modalDesign
            btnAccept
            classNameContent="modal-confirm report"
            classNameBtn="btn_modal pink report"
          />
        ) : (
          ''
        )}
        {modalErrorDate ? (
          <PopUp
            open={modalErrorDate}
            close={closeModal}
            icon={alertIcon}
            title={t('title-modal-2')}
            description={t('description-modal-2')}
            go={t('keep-it')}
            accept={closeModal}
            modalDesign
            btnAccept
            classNameContent="modal-confirm report"
            classNameBtn="btn_modal pink report"
          />
        ) : (
          ''
        )}
        <FixedJobRequest />
        <div className="content_dynamic history block-job-requests report">
          <Row className="content_maintenace">
            <div className="header-content">
              <div className="info-tittle">
                <h1 className="title-maintenances">{t('title')}</h1>
                <p>{t('description')}</p>
              </div>
            </div>
          </Row>
          <div className="block-form">
            <form key={1} onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
              <Row className="no-gutters">
                <Col  xs={12} md={12} lg={4} sm={12} className="block-job">
                  <label
                    htmlFor="type"
                    className={`col-form-label ${errors.type ? 'error_label' : ''}`}
                  >
                    {t('type')}
                  </label>
                  <select
                    value={typeExcel > 0 ? typeExcel : ''}
                    className="form-control"
                    id="type"
                    name="type"
                    ref={register({
                      required: { value: true, message: t('required-field') },
                    })}
                    onChange={(e) => {
                      useSetTypeExcel(e.target.value);
                      setIsCompleted(e.target.value.length > 0);
                    }}
                  >
                    <option value="" disabled>
                      {t('default-select')}
                    </option>
                    <option value="1">{t('maintenance-requests')}</option>
                    <option value="2">{t('vehicles')}</option>
                    <option value="3" hidden>
                      {t('plans')}
                    </option>
                  </select>

                  {errors.type && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.type.message}
                      </p>
                    </div>
                  )}
                </Col>
                <Col xs={12} md={12} lg={4} sm={12} className="block-job">
                  <label
                    htmlFor="date"
                    className={`col-form-label ${errors.date ? 'error_label' : ''}`}
                  >
                    {t('date')}
                  </label>
                  <Controller
                    control={control}
                    name="date"
                    defaultValue={moment()}
                    render={(props) => (
                      <DatePicker
                        defaultValue={moment()}
                        placeholder=""
                        id="date"
                        name="date"
                        className="form-control"
                        minDate={new Date('01-01-2020')}
                        popupClassName="date-report"
                        onChange={(date) => {
                          console.log(date);
                          props.onChange(date);
                          setIsCompleted(!!date);
                        }}
                        selected={props.value}
                        onSelect={(date) => onPanelChange(date)}
                        suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                      />
                    )}
                    rules={{
                      required: { value: true, message: t('required-field') },
                    }}
                  />
                  {errors.date && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.date.message}
                      </p>
                    </div>
                  )}
                </Col>
                <Col xs={12} md={12} lg={4} sm={12} className="block-job">
                  <label
                    htmlFor="dateEnd"
                    className={`col-form-label ${errors.dateEnd ? 'error_label' : ''}`}
                  >
                    {t('end')}
                  </label>
                  <Controller
                    control={control}
                    name="dateEnd"
                    defaultValue={moment()}
                    render={(props) => (
                      <DatePicker
                        defaultValue={moment()}
                        placeholder=""
                        id="dateEnd"
                        name="dateEnd"
                        className="form-control"
                        minDate={new Date('01-01-2020')}
                        popupClassName="date-report"
                        onChange={(date) => {
                          props.onChange(date);
                          setIsCompleted(!!date);
                        }}
                        selected={props.value}
                        onSelect={(date) => onPanelChange2(date)}
                        suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                      />
                    )}
                    rules={{
                      required: { value: true, message: t('required-field') },
                    }}
                  />
                  {errors.dateEnd && (
                    <div className="error_input">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.dateEnd.message}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>
              <br />
              <div className="input-required">
                <p>{t('required')}</p>
              </div>
              <div className="block-button">
                <button
                  id="BtnSubmit"
                  type="submit"
                  className={` btn btn-primary button-job ${
                    isCompleted ? 'send_register register orange' : 'send_register register grey'
                  } `}
                >
                  {t('download')}
                </button>
              </div>
            </form>
          </div>
        </div>

        {messageAlert && (
          <Alert variant="warning">
            <Alert.Heading>
              <img src={infoAlert} alt={t('alt:notification')} />
              <strong>{t('alert:title-info-contact')}</strong>
            </Alert.Heading>
            <p>
              {t('alert:info-contact1')} {contacNumber()} {t('alert:info-contact2')}
              <strong> {contactEmail()} </strong>
            </p>
          </Alert>
        )}

        {alertUpdate && (
          <Alert variant="success" className="alert-response">
            <img src={successAlert} alt={t('alt:successAlert')} /> <p>{t('alert:save')}</p>
          </Alert>
        )}
        {messageError && (
          <Alert variant="danger" className="alert-response">
            <img src={errorAlert} alt={t('alt:errorAlert')} />
            <p>{t('alert:error')}</p>
          </Alert>
        )}
      </>
    </Template>
  );
}

JobRequest.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['report', 'alert', 'alt'])(JobRequest);
